<template>
  <div class="leng">
    <select v-model="activeLocale" class="select">
      <option
        v-for="{ locale, title, sFlag } in locales"
        :key="locale"
        :value="locale"
      >
        {{ sFlag }} {{ title }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "LangSwitch",
  props: {
    isShort: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  computed: {
    locales() {
      return [
        {
          locale: "en",
          title: this.isShort ? "EN" : "English",
          sFlag: "🇬🇧",
        },
        {
          locale: "es",
          title: this.isShort ? "ES" : "Español",
          sFlag: "🇪🇸",
        },
        {
          locale: "po",
          title: this.isShort ? "PO" : "Portugues",
          sFlag: "🇵🇹",
        },
      ];
    },
    activeLocale: {
      get() {
        return this.$i18n.locale;
      },
      set(locale) {
        const url = new URL(window.location);
        const tenYearsInSeconds = 60 * 60 * 24 * 365 * 10;
        window.$cookies.set(
          "locale",
          locale,
          tenYearsInSeconds,
          null,
          url.hostname,
        );
        this.$i18n.locale = locale;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.leng {
  position: relative;
  cursor: pointer;

  .select {
    background-color: var(--body-color);
    border: none;
    border-radius: 0;
    color: var(--font-color);
    transition: all 0.2s linear;
    padding: 7px;
    padding-right: 30px;
    cursor: pointer;

    &:hover {
      background-color: var(--select-hover-color);
    }

    &:focus,
    &:focus-visible {
      border: none;
      box-shadow: none;
      outline: none;
      // outline: var(--brand-color) auto 1px;
    }
  }

  &::after {
    content: ">";
    position: absolute;
    right: 6px;
    top: 4px;
    transform: rotateZ(90deg) scaleY(1.5);
    font-size: 22px;
    border-top-color: var(--font-color);
    pointer-events: none;
  }
}
</style>
